import { decodeHTML } from "entities";
import xss from "xss";

// For HTML attributes - strips all HTML, keeps only text
export const sanitizeAttribute = (value) => {
  if (typeof value !== "string") return value;
  return xss(value, {
    whiteList: {},
    stripIgnoreTag: true,
    stripIgnoreTagBody: ["script"],
  });
};

// For text content that might contain HTML (like your job descriptions)
export const sanitizeContent = (content) => {
  if (!content) return content;

  const whiteList = xss.getDefaultWhiteList();
  whiteList.span.push("class");
  whiteList.figure.push("contenteditable", "class");
  whiteList.iframe = ["width", "height", "src", "style"];

  return xss.filterXSS(decodeHTML(content), { whiteList });
};
